module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9clPW"))).then(() => module.bundle.root('ewmtE'));